import whiteBars from 'img/bars-white.svg'
import leftArrow from 'img/caret-left.svg'
import rightArrow from 'img/caret-right.svg'
import React from 'react'
import 'css/components/lesson-builder/slide-nav.css'

const computeSlideLabel = (slides, currentIdx) => {
	const current = slides[currentIdx]
	if (!current) return `${currentIdx + 1}`
	const presentationSlides = slides.filter(s => s.type === 'presentation')
	if (current.type === 'presentation') {
		const pos = presentationSlides.findIndex(s => s === current)
		return String(pos + 1)
	} else {
		const parentIdx = presentationSlides.findIndex(s => s.index === current.slide)
		const siblings = slides
			.filter(s => s.type !== 'presentation' && s.slide === current.slide)
			.toSorted((a, b) => a.priority < b.priority)
		const sibPos = siblings.findIndex(s => s === current)
		return `${parentIdx + 1}.${sibPos + 1}`
	}
}

export const SlideNav = ({ slides, currentSlide, onChange, onToggleSidebar }) => {
	const slideLabel = computeSlideLabel(slides, currentSlide)
	const lastSlideLabel = computeSlideLabel(slides, slides.length - 1)

	return (
		/* Buttons, not spans. These three were <span onClick>, which a
		   keyboard cannot reach at all -- no focus, no Enter, no Space --
		   so the slide navigation on the busiest screen in the app was
		   mouse-only. Each one's name comes from its icon's alt.

		   `disabled` rather than only the `disable` class: the class styles
		   it (opacity, pointer-events) but leaves it in the tab order as a
		   focusable control that silently does nothing. The attribute takes
		   it out of the tab order, which is what "disabled" has to mean for
		   anyone not using a mouse. The class stays for the appearance. */
		<div className="slide-nav">
			<button
				type="button"
				className="toggle-sidebar"
				onClick={onToggleSidebar}
			>
				<img src={whiteBars} alt="Show or hide the slide list" />
			</button>
			<button
				type="button"
				className={"prev " + (
					currentSlide === 0 ? 'disable' : ''
				)}
				disabled={currentSlide === 0}
				onClick={() => onChange(currentSlide - 1)}
			>
				<img src={leftArrow} alt="Previous slide" />
			</button>
			<span className="slide-counter">
				{slideLabel} / {lastSlideLabel}
			</span>
			<button
				type="button"
				className={"next " + (
					currentSlide === slides.length - 1 ? 'disable' : ''
				)}
				disabled={currentSlide === slides.length - 1}
				onClick={() => onChange(currentSlide + 1)}
			>
				<img src={rightArrow} alt="Next slide" />
			</button>
		</div>
	)
}
